module.exports = __webpack_public_path__ + "static/media/Edit File.d88444d0.svg";